import Login from './Login';
import HomePage from './HomePage';
import Profile from './Profile';

import Reports from './Reports';
import rep_client_list from './rep_client_list';
import rep_advisor_client_list from './rep_advisor_client_list';
import Monthly_client_list from './Monthly_client_list';

import ManageOrganisation from './ManageOrganisation';
import AddOrganisation from './AddOrganisation';

import ManageUsers from './ManageUsers';
import AddUser from './AddUser';
import ViewUser from './ViewUser';
import ViewOrganisation from './ViewOrganisation';
import VUt_Allocations from './VUt_Allocations';
import VUt_User_message from './VUt_User_message';
import VUt_User_commslog from './VUt_User_commslog';
import VUt_Navigation from './VUt_Navigation';
import VUt_Organisations from './VUt_Organisations';
import VUt_UserDetails from './VUt_UserDetails';

import ManageApplications from './ManageApplications';
import my_wills from './my_wills';
import ManageAdvisors from './ManageAdvisors';
import AdvisorGroups from './AdvisorGroups';
import ViewAdvisorGroup from './ViewAdvisorGroup';
import bulk_change_advisor from './bulk_change_advisor';
import AddApplication from './AddApplication';
import ViewApplication from './ViewApplication';
import ViewAdvisor from './ViewAdvisor';
import ManageLeads from './ManageLeads';
import Dashboard from './Dashboard';
import dashboard_allocation from './dashboard_allocation';
import AddLead from './AddLead';
import ViewLead from './ViewLead';
import VLd_Details from './VLd_Details';
import VLd_ContactReports from './VLd_ContactReports';
import VAd_Details from './VAd_Details';
import VAd_ContactReports from './VAd_ContactReports';
import VAd_CommsLog from './VAd_CommsLog';
import VAd_WillsApplications from './VAd_WillsApplications';
import VAt_Overview from './VAt_Overview';
import VAt_Client_Overview from './VAt_Client_Overview';
import VAt_AppDetails from './VAt_AppDetails';
import VAt_Will from './VAt_Will';
import VAt_Will_advisor from './VAt_Will_advisor';
import VAt_History from './VAt_History';
import VAt_Withdrawal from './VAt_Withdrawal';
import VAt_SummaryDocument from './VAt_SummaryDocument';
import VAt_Documentation from './VAt_Documentation';
import ADs_PersonalDetails from './ADs_PersonalDetails';
import ADs_MaritalStatus from './ADs_MaritalStatus';
import ADs_ChildrenDetails from './ADs_ChildrenDetails';
import ADs_Heirs from './ADs_Heirs';
import ADs_Trust from './ADs_Trust';
import ADs_Guardian from './ADs_Guardian';
import ADs_Equity from './ADs_Equity';
import ADs_Devise from './ADs_Devise';
import ADs_submit_advisor_review from './ADs_submit_advisor_review';
import Email_templates from './Email_templates';
import Email_template_detail from './Email_template_detail';
import wo_elements from './wo_elements';



export default {
  Login,
  HomePage,
  Profile,
  Reports,
  rep_client_list,
  rep_advisor_client_list,
  Monthly_client_list,

  ManageOrganisation,
  AddOrganisation,
  ViewOrganisation,
  
  ManageUsers,
  AddUser,
  ViewUser,
  VUt_Navigation,
  VUt_Organisations,
  VUt_UserDetails,
  VUt_Allocations,
  VUt_User_message,
  VUt_User_commslog,
  
  ManageApplications,
  my_wills,
  my_will: my_wills,
  ManageAdvisors,
  AdvisorGroups,
  ViewAdvisorGroup,
  bulk_change_advisor,
  AddApplication,
  ViewApplication,
  ViewAdvisor,
  ManageLeads,
  Dashboard,
  dashboard_allocation,
  AddLead,
  ViewLead,
  VLd_Details,
  VLd_ContactReports,
  VAd_Details,
  VAd_ContactReports,
  VAd_CommsLog,
  VAd_WillsApplications,
  VAt_Overview,
  VAt_Client_Overview,
  VAt_Withdrawal,
  VAt_SummaryDocument,
  VAt_Documentation,
  VAt_History,
  VAt_AppDetails,
  ADs_PersonalDetails,
  ADs_MaritalStatus,
  ADs_ChildrenDetails,
  ADs_Devise,
  ADs_Heirs,
  ADs_Trust,
  ADs_Guardian,
  ADs_Equity,
  ADs_submit_advisor_review,
  VAt_Will,
  VAt_Will_advisor,
  Email_templates,
  Email_template_detail,
  wo_elements,
};
